import { render } from "./requests.vue?vue&type=template&id=1c6f8f44&scoped=true"
import script from "./requests.vue?vue&type=script&lang=js"
export * from "./requests.vue?vue&type=script&lang=js"

import "./requests.vue?vue&type=style&index=0&id=1c6f8f44&lang=scss"
import "./requests.vue?vue&type=style&index=1&id=1c6f8f44&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c6f8f44"]])

export default __exports__